export const multiSelectEquipmentCategory = {
    bindings: {
        module: '@',
        identifier: '@'
    },
    template: require('./multi-select-equipment-category.html'),
    controller: 'MultiSelectEquipmentCategoryController'
};
